export default "__VITE_ASSET__49698b83__"